import type { Bootgrid } from "./bootgrid";

function calculateTotalRow(bootgrid: Bootgrid): any {
    if (!bootgrid.bootgridSettings.totalRowConfig.columnConfigs?.length) {
        return null;
    }

    const dataRows: HTMLTableRowElement[] = Array.from(bootgrid.$bootgrid.find('tbody > tr:not(.total-row)') as any);
    if (dataRows.length === 0) {
        return null;
    }

    const totalRow: any = {};

    bootgrid.bootgridSettings.totalRowConfig.columnConfigs.forEach(config => {
        const columnId = config.columnId;

        const values = dataRows
            .map((row) => {
                const cellElement = $(row).find(`td[data-column-id="${columnId}"]`);
                if (cellElement.length === 0) return NaN;
                const val = cellElement.data('cell-value');
                return typeof val === 'number' ? val : parseFloat(val);
            })
            .filter((val) => !isNaN(val));

        if (values.length === 0) {
            totalRow[columnId] = '';
            return;
        }

        totalRow[columnId] = values.reduce((a: number, b: number) => a + b, 0);
    });

    return totalRow;
}

export function renderTotalRow(bootgrid: Bootgrid): void {
    if (!bootgrid.bootgridSettings.totalRowConfig.columnConfigs?.length) {
        removeTotalRow(bootgrid);
        return;
    }

    const tbody = bootgrid.$bootgrid.find('tbody').first();
    if (tbody.length === 0) {
        return;
    }

    removeTotalRow(bootgrid);

    const totalRow = calculateTotalRow(bootgrid);

    if (!totalRow) {
        return;
    }

    const columns = bootgrid.getDisplayedColumns();
    let cells = '';

    if (bootgrid.bootgridSettings.allowSelection) {
        cells += `<td class="select-cell"></td>`;
    }

    // Add empty commands cell if data rows have it (for alignment when row is editable)
    const hasCommandsColumn = bootgrid.$bootgrid.find('tbody > tr:not(.total-row) > td[data-column-id="commands"]').length > 0;
    if (hasCommandsColumn) {
        cells += `<td data-column-id="commands"></td>`;
    }

    columns.forEach(col => {
        let value = totalRow[col.columnId] ?? '';

        if (col.columnId === columns[0].columnId) {
            value = bootgrid.config.translations.captionTotal;
        } else if (typeof value === 'number') {
            // Use the same formatter the bootgrid uses for this column
            const columnSettings = (bootgrid.$bootgrid as any).bootgrid('getColumnSettings') as any[];
            const colSetting = columnSettings.find((c: any) => c.id === col.columnId);

            if (colSetting?.formatter) {
                const fakeRow: any = {};
                fakeRow[col.columnId] = value;
                value = colSetting.formatter.call(null, colSetting, fakeRow);
            } else {
                value = Number(value).toLocaleString(bootgrid.config.culture);
            }
        }

        // Copy style from an existing data cell in the same column
        const existingDataCell = bootgrid.$bootgrid.find(`tbody > tr:not(.total-row) > td[data-column-id="${col.columnId}"]`).first();
        const inlineStyle = existingDataCell.length > 0 ? existingDataCell.attr('style') || '' : '';
        const cssClass = 'total-cell';
        cells += `<td class="${cssClass}" data-column-id="${col.columnId}" style="${inlineStyle}">${value === '' ? '&nbsp;' : value}</td>`;
    });

    const totalRowHtml = `<tr class="total-row" data-row-type="total">${cells}</tr>`;
    tbody.append(totalRowHtml);
}

export function removeTotalRow(bootgrid: Bootgrid): void {
    bootgrid.$bootgrid.find('tbody tr.total-row').remove();
}